// Deterministic $ROBBED "Tokenomics Share Card" — pure canvas (no external images, no AI).
// Reads values from the tokenomics single source of truth (settings.tokenomics) passed in.
const COLORS = ["#00FF66", "#A855F7", "#FFD700", "#FF3366", "#F5F5F0"];

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
};

const shortAmt = (n) => {
  n = Number(n) || 0;
  if (n >= 1e9) return (n / 1e9).toFixed(n % 1e9 ? 2 : 0).replace(/\.0+$/, "") + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(n % 1e6 ? 1 : 0).replace(/\.0+$/, "") + "M";
  return n.toLocaleString();
};

export function renderTokenomicsCard(canvas, tk, handle = "@robbedcoin") {
  const W = 1080, H = 1080;
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  const neon = "#00FF66", cream = "#F5F5F0", dim = "#9a9a9a", ink = "#0b0b0d", ink2 = "#151517", danger = "#FF3366";
  const alloc = tk.allocation || [];

  // background + faint diagonal stripes
  ctx.fillStyle = ink; ctx.fillRect(0, 0, W, H);
  ctx.save();
  ctx.globalAlpha = 0.05; ctx.strokeStyle = neon; ctx.lineWidth = 24;
  for (let i = -H; i < W; i += 74) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i + H, H); ctx.stroke(); }
  ctx.restore();

  // frames
  ctx.strokeStyle = "#000"; ctx.lineWidth = 40; ctx.strokeRect(20, 20, W - 40, H - 40);
  ctx.strokeStyle = neon; ctx.lineWidth = 8; ctx.strokeRect(46, 46, W - 92, H - 92);

  const L = 96, R = W - 96, cx = W / 2;

  // top row: wordmark + PLANNED tag
  ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
  ctx.fillStyle = neon; ctx.font = "900 54px 'Arial Black', Impact, sans-serif";
  ctx.fillText("$ROBBED", L, 138);
  const tag = "PLANNED — NOT DEPLOYED";
  ctx.font = "800 22px 'Arial Black', sans-serif";
  const tw = ctx.measureText(tag).width + 32;
  roundRect(ctx, R - tw, 108, tw, 40, 8); ctx.fillStyle = danger; ctx.fill();
  ctx.fillStyle = "#fff"; ctx.textAlign = "center"; ctx.fillText(tag, R - tw / 2, 136);

  // title
  ctx.textAlign = "left"; ctx.fillStyle = cream; ctx.font = "900 84px 'Arial Black', Impact, sans-serif";
  ctx.fillText("TOKENOMICS", L, 232);

  // total planned supply
  ctx.fillStyle = dim; ctx.font = "800 24px 'Arial Black', sans-serif";
  ctx.fillText("TOTAL PLANNED SUPPLY", L, 282);
  ctx.fillStyle = neon; ctx.font = "900 82px 'Arial Black', Impact, sans-serif";
  ctx.fillText(Number(tk.plannedTotalSupply).toLocaleString(), L, 366);

  // stacked allocation bar
  const barY = 404, barH = 40;
  let bx = L; const barW = R - L;
  alloc.forEach((a, i) => {
    const w = (a.percent / 100) * barW;
    ctx.fillStyle = COLORS[i % COLORS.length];
    ctx.fillRect(bx, barY, w, barH);
    bx += w;
  });
  ctx.strokeStyle = "#000"; ctx.lineWidth = 6; ctx.strokeRect(L, barY, barW, barH);

  // allocation rows — percentage visually dominant
  let ry = 498;
  const rowH = 90;
  alloc.forEach((a, i) => {
    const color = COLORS[i % COLORS.length];
    // swatch
    ctx.fillStyle = color; ctx.fillRect(L, ry - 42, 38, 38);
    ctx.strokeStyle = "#000"; ctx.lineWidth = 5; ctx.strokeRect(L, ry - 42, 38, 38);
    // big percent (dominant)
    ctx.fillStyle = color; ctx.textAlign = "left"; ctx.font = "900 60px 'Arial Black', Impact, sans-serif";
    ctx.fillText(`${a.percent}%`, L + 58, ry);
    // name (top) + amount (below), stacked to avoid overlap
    ctx.fillStyle = cream; ctx.font = "800 28px 'Arial Black', sans-serif";
    ctx.fillText(a.name.toUpperCase(), L + 230, ry - 16);
    ctx.fillStyle = dim; ctx.font = "700 24px 'Arial Black', sans-serif";
    ctx.fillText(`${shortAmt(a.amount)} $ROBBED`, L + 230, ry + 14);
    ry += rowH;
  });

  // divider
  ctx.strokeStyle = "rgba(255,255,255,0.12)"; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.moveTo(L, 928); ctx.lineTo(R, 928); ctx.stroke();

  // footer: chains + planned + handle
  ctx.textAlign = "left"; ctx.fillStyle = neon; ctx.font = "900 30px 'Arial Black', Impact, sans-serif";
  ctx.fillText("SOLANA + ROBINHOOD CHAIN", L, 972);
  ctx.fillStyle = dim; ctx.font = "700 22px 'Arial Black', sans-serif";
  ctx.fillText("ONE UNIFIED SUPPLY · PLANNED ALLOCATION", L, 1004);
  ctx.textAlign = "right"; ctx.fillStyle = cream; ctx.font = "900 34px 'Arial Black', Impact, sans-serif";
  ctx.fillText(handle, R, 984);
}
